import { ReactNode } from "react";
import { TooltipContainer } from "@sellar-io/components";

export const DeliveryChargeCapToolTip = ({
  children,
}: {
  children: ReactNode;
}) => {
  return (
    <TooltipContainer enable placement="top" text="Courier charge cap applied">
      {children}
    </TooltipContainer>
  );
};
